var _objectSpread = require("/var/lib/jenkins/jobs/LiDARnetics - Client - PROD_REDUX deploy/workspace/lidarnetics_client_prod_redux/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectSpread");

var _classCallCheck = require("/var/lib/jenkins/jobs/LiDARnetics - Client - PROD_REDUX deploy/workspace/lidarnetics_client_prod_redux/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/var/lib/jenkins/jobs/LiDARnetics - Client - PROD_REDUX deploy/workspace/lidarnetics_client_prod_redux/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var headerBlock = require('./headerBlock');

var _require = require('./helper'),
    validateEpsg = _require.validateEpsg,
    bufferFlipper = _require.bufferFlipper,
    uint8arrayToString = _require.uint8arrayToString;

var readHeader = /*#__PURE__*/function () {
  "use strict";

  function readHeader() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, readHeader);

    this.inpuBuffer = options.inpuBuffer;
    this.inputArrayBuffer = options.inputArrayBuffer;
    this.inputDataView = options.inputDataView;
    this.currentByte = 0;
    this.numOfVarLenRecords = 0;
    this.projectionStart = 0;
  }

  _createClass(readHeader, [{
    key: "getValues",
    value: function getValues() {
      var _this = this;

      var publicHeaderBlock = {};
      headerBlock.publicHeaderBlock.forEach(function (obj) {
        var myObj = _this.getValue(_objectSpread({}, obj));

        if (myObj !== undefined) {
          if (myObj[0] === 'FileSignature' && myObj[1] !== 'LASF') {
            throw new Error('Ivalid FileSignature. Is this a LAS/LAZ file');
          }

          publicHeaderBlock[myObj[0]] = myObj[1];
        }
      });
      var variableRecords = [];

      var _loop = function _loop(i) {
        var variableObj = {};
        headerBlock.variableLengthRecord.forEach(function (obj) {
          var myObj = _this.getValue(_objectSpread({}, obj));

          variableObj[myObj[0]] = myObj[1];

          if (myObj[0] === 'UserId' && myObj[1] === 'LASF_Projection') {
            _this.projectionStart = _this.currentByte - 18 + 54;
          }
        });
        variableRecords.push(variableObj);
      };

      for (var i = 0; i < this.numOfVarLenRecords; i++) {
        _loop(i);
      }

      var geoRecord = variableRecords.find(function (x) {
        return x.UserId === 'LASF_Projection';
      });
      var epsg = this.getGeoKeys(geoRecord);
      publicHeaderBlock['epsg'] = epsg;
      return publicHeaderBlock;
    }
  }, {
    key: "getGeoKeys",
    value: function getGeoKeys(geoRecord) {
      if (geoRecord === undefined) {
        return undefined;
      }

      var projectionEnd = this.projectionStart + geoRecord.RecordLengthAfterHeader;
      var geoTag = this.inpuBuffer.slice(this.projectionStart, projectionEnd);
      var inputArrayBuffer = bufferFlipper(geoTag);
      var dataView = new DataView(inputArrayBuffer);
      var byteCount = 6;
      var numberOfKeys = Number(dataView.getUint16(byteCount, true));
      var geoKeys = [];

      while (numberOfKeys--) {
        var keyTmp = {};
        keyTmp.key = dataView.getUint16(byteCount += 2, true);
        keyTmp.tiffTagLocation = dataView.getUint16(byteCount += 2, true);
        keyTmp.count = dataView.getUint16(byteCount += 2, true);
        keyTmp.valueOffset = dataView.getUint16(byteCount += 2, true);
        geoKeys.push(keyTmp);
      }

      var projRecord = geoKeys.find(function (x) {
        return x.key === 3072;
      });

      if (projRecord && projRecord.hasOwnProperty('valueOffset')) {
        var epsg = projRecord.valueOffset;

        if (validateEpsg(epsg)) {
          return epsg;
        }

        return undefined;
      }

      return undefined;
    }
  }, {
    key: "getValue",
    value: function getValue(_ref) {
      var item = _ref.item,
          format = _ref.format,
          size = _ref.size;
      var str, array;

      switch (format) {
        case 'char':
          array = new Uint8Array(this.inputArrayBuffer, this.currentByte, size);
          this.currentByte += size;
          str = uint8arrayToString(array);
          return [item, str];

        case 'uShort':
          str = this.inputDataView.getUint16(this.currentByte, true);
          this.currentByte += size;
          return [item, str];

        case 'uLong':
          str = this.inputDataView.getUint32(this.currentByte, true);

          if (item === 'NumberOfVariableLengthRecords') {
            this.numOfVarLenRecords = str;
          }

          this.currentByte += size;
          return [item, str];

        case 'uChar':
          str = this.inputDataView.getUint8(this.currentByte);
          this.currentByte += size;
          return [item, str];

        case 'double':
          str = this.inputDataView.getFloat64(this.currentByte, true);
          this.currentByte += size;
          return [item, str];

        default:
          this.currentByte += size;
      }
    }
  }]);

  return readHeader;
}();

;
module.exports = readHeader;